import styled from "styled-components";

const PlatformPhoto = styled.div`
  position: relative;

  #photoInput {
    display: none;
  }

  .platformImg {
    position: absolute;
    overflow: hidden;
    bottom: 0;
    height: 1.6rem;
    width: 1.6rem;
    left: 2.4rem;
    border: 1px solid #ffffff;
    border-radius: 50%;
  }

  @media screen and (max-width: 768px) {
    .platformImg {
      height: 12px;
      width: 12px;
      left: 18px;

      .icon {
        height: 16px;
      }
    }

    .imgWrapper {
      height: 3.2rem;
    }
  }
`;

export default PlatformPhoto;